import styled, { css } from 'styled-components';

import { Table } from 'reactstrap';

import NumberFormat from 'react-number-format';

export const Container = styled.div`
  height: calc(100vh - 48px);
  overflow-y: scroll;
  padding: 20px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  gap: 16px;
`;

export const ProductsTable = styled(Table)`
  width: 100%;
  margin: 10px auto 30px auto;
  border-collapse: initial;
  border-spacing: 0 20px;
  overflow: hidden;
  padding: 0 30px;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      border-top: 1px solid #33333310;
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const ProductImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin: 10px 5px 10px 0;
  cursor: pointer;

  ${(props) =>
    props.available &&
    css`
      img {
        opacity: 0.7;
      }
    `}

  &:hover {
    opacity: 0.5;
  }
`;

export const NoImage = styled.div`
  width: 80px;
  height: 80px;
  cursor: pointer;
  background: #33333330;
  border-radius: 8px;
  margin-bottom: 8px;
`;

export const ProductName = styled.p`
  max-width: 390px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  color: #222 !important;

  @media (max-width: 1679px) {
    min-width: 200px;
    max-width: 200px;
  }

  @media (max-width: 1026px) {
    min-width: 100px;
    max-width: 100px;
  }
`;

export const MenuItemPromotion = styled.p`
  color: red;
  text-decoration: line-through;
  filter: opacity(60%);
`;

export const NumberFormatStyled = styled(NumberFormat)`
  height: 44px;
  width: 120px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  margin-top: 8px;

  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 8px;
  }
`;

export const SubmitStyledButton = styled.button`
  height: 44px;
  width: 44px;
  padding: 10px;
  border-radius: 8px;
  border: none;
  margin-top: 8px;
  margin-left: 8px;
  background-color: #0ccab4;

  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.lightGray};

    svg {
      filter: opacity(0.3);
      color: #333;
    }
  }
`;
